import BusinessIcon from "@mui/icons-material/Business";
import PublishIcon from "@mui/icons-material/Publish";
import SettingsIcon from "@mui/icons-material/Settings";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { OpportunityTypeFilter } from "../../../components/filters/OpportunityType/OpportunityTypeFilter";
import { TargetOrganizationsFilter } from "../../../components/filters/TargetOrganizations/TargetOrganizationsFilter";
import { EmployeeRangeFilter } from "../../../components/filters/UserFilters/EmployeesRangeFilter";
import { GeographyFilter } from "../../../components/filters/UserFilters/GeographyFilter";
import { GlobalPresenceFilter } from "../../../components/filters/UserFilters/GlobalPresenceFilter/GlobalPresenceFilter";
import { IndustryFilter } from "../../../components/filters/UserFilters/IndustryFilter";
import { ProductAttributesFilter } from "../../../components/filters/UserFilters/ProductAttributesFilter";
import { ProductCategoriesFilter } from "../../../components/filters/UserFilters/ProductCategoriesFilter";
import { ProductsFilter } from "../../../components/filters/UserFilters/ProductsFilter/ProductsFilter";
import { RevenueRangeFilter } from "../../../components/filters/UserFilters/RevenueRangeFilter";
import { UploadedAccountsFilter } from "../../../components/filters/UserFilters/UploadedAccountsFilter";
import { VendorsFilter } from "../../../components/filters/UserFilters/VendorsFilter/VendorsFilter";
import { FilterGroup } from "./FiltersDialog/types";
import { FilterConflictType } from "../utils";

export const FILTERS_KEYS = {
  companyMatch: "companyMatch",
  opportunityType: "opportunityType",
  targetOrganizations: "targetOrganizations",
  geography: "geography",
  globalPresence: "globalPresence",
  companyType: "companyType",
  industry: "industry",
  revenue: "revenue",
  employees: "employees",
  spend: "spend",
  productCategories: "productCategories",
  products: "products",
  vendors: "vendors",
  productAttributes: "productAttributes",
};

export const FILTER_TYPE_MAP: { [key: string]: FilterConflictType } = {
  geography: "geography",
  employees: "employee",
  revenue: "revenue",
  industry: "industry",
  products: "products",
};

export const FILTERS_GROUP: FilterGroup[] = [
  {
    id: "uploaded-accounts-filter",
    title: "Uploaded Accounts",
    icon: <PublishIcon />,
    items: [
      {
        id: "uploaded-accounts-item-filter",
        label: "Uploaded Accounts",
        filterKey: FILTERS_KEYS.companyMatch,
        content: <UploadedAccountsFilter />,
      },
    ],
  },
  {
    id: "opportunity-type-filter",
    title: "Opportunity Type",
    icon: <TrendingUpIcon />,
    items: [
      {
        id: "opportunity-type-item-filter",
        label: "Opportunity Type",
        filterKey: FILTERS_KEYS.opportunityType,
        content: <OpportunityTypeFilter />,
      },
    ],
  },
  {
    id: "firmographics-filter",
    title: "Firmographics",
    icon: <BusinessIcon />,
    items: [
      {
        id: "target-organizations-filter",
        label: "Target Organizations",
        filterKey: FILTERS_KEYS.targetOrganizations,
        content: <TargetOrganizationsFilter />,
      },
      {
        id: "geography-filter",
        label: "Geography",
        filterKey: FILTERS_KEYS.geography,
        content: <GeographyFilter />,
      },
      {
        id: "global-presence-filter",
        label: "Global Presence",
        filterKey: FILTERS_KEYS.globalPresence,
        content: <GlobalPresenceFilter />,
      },
      {
        id: "industry-filter",
        label: "Industry",
        filterKey: FILTERS_KEYS.industry,
        content: <IndustryFilter />,
      },
      {
        id: "revenue-range-filter",
        label: "Revenue",
        filterKey: FILTERS_KEYS.revenue,
        content: <RevenueRangeFilter />,
      },
      {
        id: "employee-range-filter",
        label: "Employee",
        filterKey: FILTERS_KEYS.employees,
        content: <EmployeeRangeFilter />,
      },
    ],
  },
  // {
  //   id: "it-spend-budget-filter",
  //   title: "IT Spend Budget",
  //   icon: <AttachMoneyIcon />,
  //   items: [
  //     // {
  //     //   id: "it-spend-budget-filter",
  //     //   label: "IT Spend Budget",
  //     //   filterKey: FILTERS_KEYS.spend,
  //     //   content: <ITSpendBudgetFilter />,
  //     // },
  //   ],
  // },
  {
    id: "tech-installs-filter",
    title: "Tech Installs",
    icon: <SettingsIcon />,
    items: [
      {
        id: "product-categories-filter",
        label: "Product Categories",
        filterKey: FILTERS_KEYS.productCategories,
        content: <ProductCategoriesFilter />,
      },
      {
        id: "products-filter",
        label: "Products",
        filterKey: FILTERS_KEYS.products,
        content: <ProductsFilter />,
      },
      {
        id: "vendors-filter",
        label: "Vendors",
        filterKey: FILTERS_KEYS.vendors,
        content: <VendorsFilter />,
      },
      {
        id: "product-attributes-filter",
        label: "Product Attributes",
        filterKey: FILTERS_KEYS.productAttributes,
        content: <ProductAttributesFilter />,
      },
    ],
  },
];

export const FILTERS = FILTERS_GROUP.flatMap((group) => {
  return group.items.map((filter) => filter);
});
